import { G } from "../constants/theme";
import { Wrap, Sec } from "../components/ui/Layout";
import PageHero from "../components/ui/PageHero";
import { BtnG, BtnO } from "../components/ui/Buttons";

const DOCS = [
  {
    num: "01",
    title: "Laboratory Analysis",
    desc: "Lab reports available to qualified buyers upon request. Includes moisture, ash, volatile matter, fixed carbon, and calorific value.",
  },
  {
    num: "02",
    title: "Product Specifications",
    desc: "Moisture 0.09%, ash 12.4%, volatile matter 0.67%, fixed carbon 64.54%, gross calorific value 21,671 kJ/kg.",
  },
  {
    num: "03",
    title: "Sample Evaluation",
    desc: "Samples arranged upon request for testing and application evaluation prior to bulk commitment.",
  },
  {
    num: "04",
    title: "Buyer Review",
    desc: "We encourage buyers to evaluate the material against their own application requirements. Full technical support available.",
  },
];

export default function Technical({ onNavigate }) {
  return (
    <>
      <PageHero
        label="Documentation"
        title={
          <>
            TECHNICAL DATA
            <br />
            &amp; DOCUMENTATION
          </>
        }
        sub="Technical information available for buyers evaluating the material for industrial use."
      />

      <Sec bg={G.black}>
        <Wrap>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 1,
              background: G.border,
              border: `1px solid ${G.border}`,
              marginBottom: 40,
            }}
          >
            {DOCS.map(({ num, title, desc }) => (
              <div
                key={num}
                style={{
                  background: G.card,
                  padding: "44px 36px",
                  position: "relative",
                  overflow: "hidden",
                  borderBottom: `1px solid ${G.border}`,
                }}
              >
                <div
                  style={{
                    fontFamily: "'Bebas Neue', sans-serif",
                    fontSize: 66,
                    color: G.border,
                    lineHeight: 1,
                    position: "absolute",
                    top: 10,
                    right: 18,
                  }}
                >
                  {num}
                </div>
                <div
                  style={{
                    fontFamily: "monospace",
                    fontSize: 11,
                    letterSpacing: 2,
                    color: G.green,
                    textTransform: "uppercase",
                    marginBottom: 14,
                  }}
                >
                  {title}
                </div>
                <p style={{ fontSize: 14, color: G.muted, lineHeight: 1.7, maxWidth: 320 }}>
                  {desc}
                </p>
              </div>
            ))}
          </div>

          <div style={{ display: "flex", gap: 14 }}>
            <BtnG onClick={() => onNavigate("contact")}>Request COA</BtnG>
            <BtnO onClick={() => onNavigate("contact")}>Request Sample</BtnO>
          </div>
        </Wrap>
      </Sec>
    </>
  );
}
